//@vendors
const { APIPost } = require('utilities/APIRequestHelper');
const { createActions } = require('redux-actions');

const simpleActions = createActions(
    'MORTGAGE_ASSOCIATED_INSURANCES',
    'MORTGAGE_ASSOCIATED_INSURANCES_ERROR',
    'MORTGAGE_ASSOCIATED_INSURANCES_SUCCESS'
);

const getMortgageAssociatedInsurances = (immMortgage = false) => (dispatch, getState) => {

    const mortgagesContractNumberIds = getState().loans.get('byId').reduce((accu, loan) => {
        if (loan.get('isMortgage')) {
            return [...accu, loan.get('newContractNumber')];
        } else {
            return accu;
        }
    }, []);

    const params = {
        query: {
            contractNumbers: immMortgage ? [immMortgage.get('newContractNumber')] : mortgagesContractNumberIds
        }
    };

    dispatch(simpleActions.mortgageAssociatedInsurances());
    return APIPost({ dispatch, endpoint: 'insuranceMortgage', params })
        .then(response => {
            dispatch(simpleActions.mortgageAssociatedInsurancesSuccess({ data: response.data }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.mortgageAssociatedInsurancesError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

module.exports = {
    simpleActions,
    getMortgageAssociatedInsurances
};
